import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity7 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_7;
}

export default CobbledRoadTileEntity7;
